<h2 mat-dialog-title class="sk-dialog-title">
  <mat-icon>assignment</mat-icon> {{isEdit ? 'Auftrag bearbeiten' : 'Neuer Auftrag'}}
</h2>

<mat-dialog-content class="dialog-content">
  <div class="section-label"><mat-icon class="sk-inline-icon">description</mat-icon> Auftrag</div>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Titel</mat-label>
    <input matInput [(ngModel)]="title" required placeholder="z.B. Rohbau Halle 3" cdkFocusInitial>
    <mat-icon matPrefix>assignment</mat-icon>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Beschreibung</mat-label>
    <textarea matInput [(ngModel)]="description" rows="3"></textarea>
  </mat-form-field>

  <div class="form-row">
    <mat-form-field appearance="outline">
      <mat-label>Auftrags-/Bestellnummer</mat-label>
      <input matInput [(ngModel)]="orderNumber">
    </mat-form-field>

    <!-- Takeda mit gepflegten Stammdaten: Auswahl. Sonst wie bisher Freitext,
         damit ohne Stammdaten kein Ort unerfassbar wird. -->
    <mat-form-field appearance="outline" *ngIf="hatEinsatzortAuswahl">
      <mat-label>Einsatzort / Baustelle</mat-label>
      <mat-select [(ngModel)]="location">
        <mat-option [value]="''">– Kein Einsatzort –</mat-option>
        <mat-option *ngFor="let name of einsatzortNamen" [value]="name">{{name}}</mat-option>
      </mat-select>
      <mat-icon matPrefix>location_on</mat-icon>
    </mat-form-field>

    <mat-form-field appearance="outline" *ngIf="!hatEinsatzortAuswahl">
      <mat-label>Einsatzort / Baustelle</mat-label>
      <input matInput [(ngModel)]="location">
      <mat-icon matPrefix>location_on</mat-icon>
      <mat-hint *ngIf="istTakeda && !stammdatenLoading">
        Noch keine Einsatzorte in den Stammdaten
      </mat-hint>
    </mat-form-field>
  </div>

  <!-- Projektnummer: nur für Takeda und nur aus Stammdaten.
       Bewusst NICHT dasselbe wie die Auftrags-/Bestellnummer oben. -->
  <div class="form-row" *ngIf="istTakeda">
    <mat-form-field appearance="outline" *ngIf="hatProjektnummerAuswahl">
      <mat-label>Projektnummer</mat-label>
      <mat-select [(ngModel)]="projektNummer">
        <mat-option [value]="null">– Keine Projektnummer –</mat-option>
        <mat-option *ngFor="let p of projektnummern" [value]="p.nummer">
          {{p.nummer}}
          <span class="sk-muted" *ngIf="p.bezeichnung"> · {{p.bezeichnung}}</span>
          <span class="sk-muted" *ngIf="!p.isActive"> (nicht mehr aktiv)</span>
        </mat-option>
      </mat-select>
      <mat-icon matPrefix>folder_special</mat-icon>
    </mat-form-field>

    <p class="sk-muted stammdaten-hinweis"
       *ngIf="!hatProjektnummerAuswahl && !stammdatenLoading">
      <mat-icon class="sk-inline-icon">info_outline</mat-icon>
      Für diesen Stammkunden sind noch keine Projektnummern hinterlegt. Sie werden
      in den Stammdaten gepflegt.
    </p>
  </div>

  <div class="section-label">
    <mat-icon class="sk-inline-icon">event</mat-icon>
    Termine
  </div>

  <div class="form-row">

    <mat-form-field appearance="outline">
      <mat-label>Auftragseingang</mat-label>

      <input matInput [matDatepicker]="receivedPicker" [(ngModel)]="receivedDate">

      <mat-datepicker-toggle matSuffix [for]="receivedPicker">
      </mat-datepicker-toggle>

      <mat-datepicker #receivedPicker></mat-datepicker>
    </mat-form-field>


    <mat-form-field appearance="outline">
      <mat-label>Geplanter Beginn</mat-label>

      <input matInput [matDatepicker]="startPicker" [(ngModel)]="startDate">

      <mat-datepicker-toggle matSuffix [for]="startPicker">
      </mat-datepicker-toggle>

      <mat-datepicker #startPicker></mat-datepicker>
    </mat-form-field>


    <mat-form-field appearance="outline">
      <mat-label>Fertigstellung bis</mat-label>

      <input matInput [matDatepicker]="duePicker" [(ngModel)]="dueDate">

      <mat-datepicker-toggle matSuffix [for]="duePicker">
      </mat-datepicker-toggle>

      <mat-datepicker #duePicker></mat-datepicker>
    </mat-form-field>

  </div>

  <div class="form-row">
    <mat-form-field appearance="outline">
      <mat-label>Bevorzugtes Lager</mat-label>
      <mat-select [(ngModel)]="primaryWarehouseId">
        <mat-option [value]="null">– Kein Lager –</mat-option>
        <mat-option *ngFor="let w of data.linkedWarehouses" [value]="w.id">{{w.name}}</mat-option>
      </mat-select>
      <mat-icon matPrefix>inventory_2</mat-icon>
    </mat-form-field>

    <mat-form-field appearance="outline" *ngIf="isEdit">
      <mat-label>Status</mat-label>
      <mat-select [(ngModel)]="status">
        <mat-option *ngFor="let s of statusOptions" [value]="s">{{statusLabels[s]}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()" [disabled]="saving">Abbrechen</button>
  <button mat-raised-button color="primary" (click)="save()" [disabled]="saving || !title.trim()">
    <mat-icon *ngIf="!saving">save</mat-icon>
    {{isEdit ? 'Speichern' : 'Anlegen'}}
  </button>
</mat-dialog-actions>